import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41f70ac0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "online-status" }
const _hoisted_2 = {
  key: 0,
  class: "ma-4 d-flex flex-column justify-center align-center"
}
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-center flex-column justify-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "Перевести смену", -1))
const _hoisted_5 = {
  key: 1,
  class: "d-flex flex-column align-center"
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex align-center"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fot-weight-bold mr-2" }, "Нет пользователей для выбора", -1))
const _hoisted_8 = { class: "d-flex justify-around" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "Перевести", -1))
const _hoisted_10 = { class: "custom-loader" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2 text-red" }, "Отмена", -1))
const _hoisted_12 = { class: "custom-loader" }
const _hoisted_13 = {
  key: 1,
  class: "d-flex align-center flex-column justify-center"
}
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = { class: "custom-loader" }
const _hoisted_16 = {
  key: 1,
  class: "ma-2"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Вы не привязаны к заведению", -1))
const _hoisted_18 = [
  _hoisted_17
]

import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { formatRuDate } from "@/utils/helpers";
import { saveErrorSnackbar } from "@/utils/snackbars";

export default /*#__PURE__*/_defineComponent({
  __name: 'OnlineStatus',
  setup(__props) {

const store = useStore();
const router = useRouter();
// loading states for buttons
const openCloseLoading = ref(false);
const shiftTransferLoading = ref(false);
const showTransferSelector = ref(false);
const userSelectedToTransfer = ref(null);
const dropDown = ref(false);

const cancelTransferShift = () => {
    showTransferSelector.value = false;
    userSelectedToTransfer.value = null;
}
const goToUserProfile = (user_id: number) => {
    if (!user_id) return;
    dropDown.value = false;
    router.push({ name: 'user', params: { id: user_id } })
}
const isShiftOpen = computed(() => store.getters["shiftService/selectShiftStatus"]);
const user = computed(() => store.getters["auth/selectUser"] || null);
const office = computed(() => {
    if (user.value && user.value.office_id) {
        return store.getters["officeService/selectOfficeById"](user.value.office_id);
    }
    return null;
})

const shiftInfo = computed(() => store.getters["shiftService/selectShift"]);
const canTransferShift = computed(() => {
    if (!shiftInfo.value || !user.value) return false;
    return shiftInfo.value.responsible_id === user.value.id;
});
const getResponsibleName = computed(() => {
    if (!shiftInfo.value) return "Неизвестно";
    const user = store.getters["usersService/selectUserById"](shiftInfo.value.responsible_id);
    return user ? user.name : "Неизвестно";
}
);
// return all users with same with my office id and not me
const usersToTransfer = computed(() => {
    if (!office.value || !user.value || !user.value.office_id) return [];
    const users = store.getters["usersService/selectAllUsers"]
    if (!users) return [];
    return users.filter((u: any) => u.office_id === user.value.office_id && u.id !== user.value.id);
});
// get user roles description
const getUserRoles = (user: any) => {
    const selector = store.getters["selectAvailableRoles"];
    if (!user || !user.roles || !selector) return 'Не определено';
    const roles = user.roles.map((r: any) => selector[r] || "");
    return roles.join(', ');
}
const handleOpenShift = async () => {
    processingLoadingState();
    await store.dispatch("shiftService/openShift");
};
const handleCloseShift = async () => {
    processingLoadingState();
    await store.dispatch("shiftService/closeShift");
};
const handleShiftTransfer = async () => {
    if (!userSelectedToTransfer.value) {
        cancelTransferShift();
        return;
    }
    shiftTransferLoading.value = true;
    const resp = await store.dispatch("shiftService/transferShift", userSelectedToTransfer.value);
    if (resp && resp.status === "error") {
        saveErrorSnackbar(resp.message);
    }
    shiftTransferLoading.value = false;
    cancelTransferShift();
};

const processingLoadingState = () => {
    openCloseLoading.value = true;
    setTimeout(() => {
        openCloseLoading.value = false;
    }, 5000);
};



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_menu, {
      modelValue: dropDown.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dropDown).value = $event)),
      "close-on-content-click": false,
      location: "start"
    }, {
      activator: _withCtx(({ props }) => [
        (isShiftOpen.value)
          ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({ key: 0 }, props, { class: "online-status__shift-open" }), {
              default: _withCtx(() => [
                _createTextVNode("mdi-clock-check-outline")
              ]),
              _: 2
            }, 1040))
          : (_openBlock(), _createBlock(_component_v_icon, _mergeProps({
              key: 1,
              color: "gray"
            }, props, { class: "online-status__shift-closed" }), {
              default: _withCtx(() => [
                _createTextVNode("mdi-clock-minus-outline")
              ]),
              _: 2
            }, 1040))
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          "min-width": "250",
          "max-width": "400",
          class: "dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (user.value)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 0,
                      "prepend-avatar": require('@/assets/noavatar.png'),
                      title: user.value && user.value.name ? user.value.name : 'Копибара',
                      subtitle: getUserRoles(user.value),
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (goToUserProfile(user.value.id)), ["stop"]))
                    }, null, 8, ["prepend-avatar", "title", "subtitle"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_icon, {
                  absolute: "",
                  class: "dialog-close__btn",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (dropDown.value = false), ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-close")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            (user.value && user.value.office_id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (isShiftOpen.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_v_list_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Заведение: " + _toDisplayString(office.value ? office.value.name : 'Заведение не найдено'), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_list_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(" Ответственный: " + _toDisplayString(getResponsibleName.value), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_list_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Смена открыта: " + _toDisplayString(shiftInfo.value.open_time ? _unref(formatRuDate)(shiftInfo.value.open_time) : 'Неизвестно'), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (canTransferShift.value)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              class: "d-flex flex-column align-center w-auto"
                            }, {
                              default: _withCtx(() => [
                                (!showTransferSelector.value)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      loading: shiftTransferLoading.value,
                                      class: "ma-2",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (showTransferSelector.value = true))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_4,
                                        _createVNode(_component_v_icon, { color: "#028179" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("mdi-transit-transfer")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["loading"]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                      (usersToTransfer.value && usersToTransfer.value.length)
                                        ? (_openBlock(), _createBlock(_component_v_select, {
                                            key: 0,
                                            fluid: "",
                                            variant: "solo",
                                            "hide-details": "",
                                            density: "compact",
                                            "item-title": "name",
                                            "item-value": "id",
                                            items: usersToTransfer.value,
                                            modelValue: userSelectedToTransfer.value,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userSelectedToTransfer).value = $event)),
                                            loading: shiftTransferLoading.value,
                                            label: "Выберите сотрудника",
                                            class: "mb-2 user-select"
                                          }, null, 8, ["items", "modelValue", "loading"]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _hoisted_7,
                                            _createVNode(_component_v_icon, {
                                              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (showTransferSelector.value = false), ["stop"]))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("mdi-check")
                                              ]),
                                              _: 1
                                            })
                                          ])),
                                      _createElementVNode("div", _hoisted_8, [
                                        (userSelectedToTransfer.value)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              loading: shiftTransferLoading.value,
                                              onClick: _withModifiers(handleShiftTransfer, ["stop"]),
                                              class: "ma-2"
                                            }, {
                                              loader: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_10, [
                                                  _createVNode(_component_v_icon, { light: "" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("mdi-cached")
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              default: _withCtx(() => [
                                                _hoisted_9,
                                                _createVNode(_component_v_icon, { color: "#028179" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("mdi-transit-transfer")
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["loading", "onClick"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_btn, {
                                          disabled: shiftTransferLoading.value,
                                          class: "ma-2",
                                          onClick: cancelTransferShift
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_11,
                                            _createVNode(_component_v_icon, { color: "#red" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("mdi-close")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["disabled"])
                                      ])
                                    ]))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_list_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              disabled: showTransferSelector.value,
                              loading: openCloseLoading.value,
                              class: "button-main",
                              onClick: _withModifiers(handleCloseShift, ["stop"])
                            }, {
                              loader: _withCtx(() => [
                                _createElementVNode("span", _hoisted_12, [
                                  _createVNode(_component_v_icon, { light: "" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-cached")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" Закрыть смену ")
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading", "onClick"])
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("h4", _hoisted_14, "Заведение: " + _toDisplayString(office.value ? office.value.name : 'Заведение не найдено'), 1),
                        _createVNode(_component_v_btn, {
                          loading: openCloseLoading.value,
                          class: "button-main",
                          onClick: _withModifiers(handleOpenShift, ["stop"])
                        }, {
                          loader: _withCtx(() => [
                            _createElementVNode("span", _hoisted_15, [
                              _createVNode(_component_v_icon, { light: "" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-cached")
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" Открыть смену ")
                          ]),
                          _: 1
                        }, 8, ["loading", "onClick"])
                      ]))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})